import $ from 'jquery'

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.bottom - (rect.bottom / 3) <= (window.innerHeight || document.documentElement.clientHeight)
    );
}

$(function() {

    $('.content p, .content > h1, .content h2, .content h3, .content img, .content ul li, .content img, .content time').each(function(){
        $(this).addClass('animate from-bottom').data('delay', 0);
    });

    $('.with-animations').each(function(){
        let delay = 0;
        $(this).find('.animate').each(function(){
            if(typeof $(this).data('delay') == 'undefined') {
                delay = (delay >= 600) ? 600 : delay + 80;
                $(this).data('delay', delay)
                //console.log(delay)
            }
        });
    });

    $('#app').addClass('show');

    $(window).on('scroll', function() {
        checkAnimations();
    });

    $('body').on('load', function() {
        checkAnimations();
    });

    checkAnimations();
});

function checkAnimations() {
    $('.animate').not('.animation-start').each(function(){
        if(isInViewport($(this)[ 0 ])) {
            let delay= $(this).data('delay');
            let that= $(this)
            setTimeout(function(){
                that.addClass('animation-start');
            }, delay);           
        }
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/partials/animations.js